module.exports = __webpack_public_path__ + "img/33_28.4caa8818.png";